import 'react-toastify/dist/ReactToastify.css';

import { LogoHi } from 'assets/vectors';
import { Button, IconButton } from 'components';
import { Input } from 'components/elements/Form';
import { useFormik } from 'formik';
import { useAuth } from 'hooks/useAuth';
import { useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { animated, useSpring } from 'react-spring';
import { Slide, toast, ToastContainer } from 'react-toastify';
import * as Yup from 'yup';

import { fadeInConfig, fadeInWidthDelayConfig } from '../animations';
import { Form, Main, Section } from '../styles';

interface FormValues {
  email: string;
  password: string;
}

export const LogIn: React.FC = () => {
  const history = useHistory();
  const { signIn } = useAuth();
  const initialValues = { email: '', password: '' };
  const fadeIn = useSpring(fadeInConfig);
  const fadeInWidthDelay = useSpring(fadeInWidthDelayConfig);

  const validationSchema = Yup.object().shape({
    email: Yup.string().required('email obrigatório').email('verifique email inserido'),
    password: Yup.string().required('password obrigatória')
  });

  const onSubmit = useCallback(async (values: FormValues) => {
    try {
      await signIn(values);
      history.push('home');
    } catch ({ message }) {
      toast.dark(message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        delay: 200,
        pauseOnFocusLoss: true,
        transition: Slide,
        draggablePercent: 60,
        role: 'alert'
      });
    }
  }, []);

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema
  });

  return (
    <Main>
      <Section style={fadeIn}>
        <IconButton
          icon="back"
          color="#fff"
          className="back-button"
          onClick={() => history.goBack()}
        />
        <Link to="/">
          <LogoHi className="logo" />
        </Link>
        <div className="description">
          <h1>Login</h1>
          <p>Por favor insira os seus dados para aceder à conta</p>
        </div>
        <Form onSubmit={formik.handleSubmit} style={fadeInWidthDelay}>
          <Input
            type="email"
            id="email"
            placeholder="email"
            autoComplete="username"
            alert={formik.touched.email && formik.errors.email ? true : false}
            {...formik.getFieldProps('email')}
          />
          <Input
            type="password"
            id="password"
            placeholder="password"
            autoComplete="current-password"
            alert={formik.touched.password && formik.errors.password ? true : false}
            {...formik.getFieldProps('password')}
          />
          <Button size="lg" type="submit">
            Entrar
          </Button>
        </Form>
        <animated.div style={fadeInWidthDelay}>
          <Link to="/recuperar">Recuperar password</Link>
        </animated.div>
      </Section>
      <ToastContainer limit={1} newestOnTop={false} rtl={false} />
    </Main>
  );
};
